import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  // Load translation files from public/locales
  .use(Backend)
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    // Fallback language if detection fails
    fallbackLng: 'en',
    
    // Available languages
    supportedLngs: ['en', 'pt', 'es'],
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',
    
    // Debug mode (disabled to reduce console noise)
    debug: false,

    // Backend configuration for loading translation files
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

    // Language detection configuration
    detection: {
      // Order of language detection methods
      order: ['localStorage', 'navigator', 'htmlTag'],
      
      // Cache user's language choice
      caches: ['localStorage'],
      
      // Don't lookup language from path, subdomain, etc.
      lookupLocalStorage: 'i18nextLng',
    },

    // Default namespace
    defaultNS: 'common',
    
    // Namespaces to load initially
    ns: ['common', 'landing', 'dashboard', 'forms', 'profile', 'animal', 'farm', 'dairy'],

    // React-i18next specific options
    react: {
      // Use Suspense for loading translations
      useSuspense: true,
      
      // Bind i18n instance to React component tree
      bindI18n: 'languageChanged',
      
      // Bind store to React component tree
      bindI18nStore: '',
      
      // How to handle missing translations
      transEmptyNodeValue: '',
      
      // Escape HTML in translations
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'em', 'span'],
    },

    // Interpolation configuration
    interpolation: {
      // React already escapes values to prevent XSS
      escapeValue: false,
    },

    // Missing key handler for development
    missingKeyHandler: (lng, ns, key) => {
      if (process.env.NODE_ENV === 'development') {
        console.warn(`Missing translation key: ${ns}:${key} for language: ${lng}`);
      }
    },

    // Load translation files on init
    initImmediate: false,
  });

export default i18n;